import { NgModule } from '@angular/core';
import { CustomLoginModule } from '../../custom-login/custom-login.module';
import { CustomLoginFormModule } from './login-form/login-form.module';
import { LoginRegisterModule, MyAccountV2UserModule } from '@spartacus/user/account/components';

@NgModule({
  imports: [CustomLoginModule, CustomLoginFormModule, LoginRegisterModule, MyAccountV2UserModule],
})
export class CustomUserAccountComponentsModule {}
